export default __webpack_public_path__ + "static/media/integration.9a6b093b.svg";